import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { TimeSheetVerficationReturnBO, TimesheetVListBO } from "./timesheet-verification.model";

@Injectable({
  providedIn: "root",
})
export class TimesheetVerificatioService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  GetAllEmployeesDropdown(): Observable<any> {
    let url = "api/Employee/GetAllEmployeesDropdown?";
    return this.http.get<any>(url, { observe: "response" }).pipe(
      map((data) => data.body),
      catchError(this.errorService.handleError)
    );
  }
  GetAllClientDropDown(): Observable<any> {
    let url = "api/Client/GetAllClientDropDown?";
    return this.http.get<any>(url, { observe: "response" }).pipe(
      map((data) => data.body),
      catchError(this.errorService.handleError)
    );
  }

  Selectbill(saveList: TimeSheetVerficationReturnBO[]): Observable<any> {
    let url = "api/Claims/saveTimesheetClaims";
    return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  downloadTimesheetVerificationExcel(getBO: TimesheetVListBO): Observable<any> {
    let url = "api/TimesheetVerification/downloadTimesheetVerificationExcel";
    return this.http.post<any>(url, getBO, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}
